import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Positionable} from '@travel-frontend/ui-components';

export const ControlContainer = styled(Positionable)(
  ({theme, position}) => css`
    width: 60px;
    ${position === 'left' &&
    css`
      background-image: linear-gradient(
        to right,
        ${theme.colors.backgroundOverlay},
        transparent
      );
    `}
    ${position === 'right' &&
    css`
      background-image: linear-gradient(
        to left,
        ${theme.colors.backgroundOverlay},
        transparent
      );
    `}
  `
);
